// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3357":"a08255b2","3408":"a08255b2","4411":"65a396cb","7953":"6af0cd9d"}[chunkId] + ".chunk.css";
};